import type { FaireProductEntity } from "../../entity_types/product";

export const p_eeje22ftf2: FaireProductEntity = {
  token: "p_eeje22ftf2",
  type: "product",
  name: "MILF Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/34f80b840a34f2de463cb1621503c5f814a6ed07bccd7259a7fdea683ad663b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b61cf958e886757b2f03c1acc4e7718d9dd05d271c7831c116db38014a71690.jpeg",
    "https://cdn.faire.com/fastly/43d1cd1419e6d90a98166f518c787c0dd38bc55787c04202996c77f18c148eab.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/cd040534279d387bb257841125066c9a18940e4e879aa9a4836f3d08f2df8015.jpeg",
    "https://cdn.faire.com/fastly/37022fef1081e946ea118f95264ccb1e122cc2ffc6c665cf0d914650fa77f619.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks will provide comfort and support to MILFs everywhere. If the sock fits... you're f*ckable, you hot mama. 🥵 🥰 \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:23.544Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
